const styles = ({ COLORS }) => ({
  avatar: {
    fontSize: '30px',
    color: '#fff',
    marginRight: '10px',
    display: 'inline-block'
  },
  name: {
    fontSize: '16px'
  },
  teacher: {
    display: 'flex',
    alignItems: 'center'
  },
  actions: {
    textAlign: 'right',
    '& > button': {
      marginLeft: '4px'
    }
  },
  label: {
    background: '#dbdbdb',
    padding: '2px 8px',
    fontWeight: 'bold',
    color: '#fff',
    borderRadius: '4px',
    margin: '0 2px 0 10px',
    whiteSpace: 'nowrap'
  },
  inactive: {
    fontWeight: 'bold',
    color: COLORS.RED.NORMAL
  },
  hoveredAction: {
    '& span': {
      fontWeight: 'bold'
    }
  },
  pending: {
    color: '#fff',
    display: 'inline',
    padding: '5px 10px',
    borderRadius: '4px',
    fontWeight: 'bold',
    background: COLORS.ALERT.WARNING.NORMAL
  },
  simpleButton: {
    padding: 0
  },
  subLabel: {
    whiteSpace: 'nowrap',
    lineHeight: 1
  }
})

export default styles
